import { createContext } from 'react';
import { Table } from '@tanstack/react-table';

import { TableProps } from '../types';

export const TableComponentsCommonPropsContext = createContext<
    TableProps & {
        isGroupedTable?: boolean;
        table: Table<any>;
        totalItems: number;
        totalPageOverride?: number;
    }
    // @ts-ignore
>({});
